/**
 * price_enquiry_controller.js — keep an open inline-description draft when
 * pricing an unpriced enquiry (Stimulus).
 *
 * The quote detail page renders the description and the price editor as
 * independent partials. A user who types a description (inline editor still
 * open, not yet saved) and then prices the enquiry would lose that draft: the
 * price POST carries only the price fields, and the server re-renders the
 * description partial from the stale saved value. This controller folds any
 * open inline-description draft into that submission so quotes.update_quote
 * persists both in one request.
 *
 * Wiring (components/detail/inline_price.html, start_open branch only — an
 * unpriced enquiry):
 *   data-controller="price-enquiry" on the <form>
 *   data-action="submit->price-enquiry#collectDrafts submit->inline-price#save"
 *
 * Stimulus fires actions in declaration order, so the hidden field is injected
 * before inline-price#save serializes the form. Blank drafts are skipped so
 * they never wipe an existing value.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        collectDrafts() {
            // Amount is owned by this form; description is the only co-editable
            // field the Add Price endpoint also accepts. An open editor is one
            // whose .inline-edit-form is visible (not .d-none).
            //
            // The draft is markup, not text: the description editor mirrors its
            // Tiptap content into a hidden textarea[name=description_html] and
            // that is what the server reconciles (RichDescriptionService.resolve
            // derives the plain column from it). Forwarding the plain name here
            // would post a plain-only payload, which clears description_html —
            // silently dropping any inline images in the draft.
            const editor = document.querySelector(
                '.inline-edit-form:not(.d-none) textarea[name="description_html"]'
            );
            if (!editor || editor.value.trim() === '') return;

            let hidden = this.element.querySelector('input[type="hidden"][name="description_html"]');
            if (!hidden) {
                hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.name = 'description_html';
                this.element.appendChild(hidden);
            }
            hidden.value = editor.value;
        }
}
